import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { NgxSpinnerService } from 'ngx-spinner';
import { ApiServiceService } from '../_service/api-service.service';


@Component({
  selector: 'app-student-dashboard',
  templateUrl: './student-dashboard.component.html',
  styleUrls: ['./student-dashboard.component.scss']
})
export class StudentDashboardComponent implements OnInit {
  userForm: any = JSON.parse(localStorage.getItem('login_user_details'));
  spinner: boolean;
 
  constructor(private router:Router,private ApiService: ApiServiceService,private spinnerService: NgxSpinnerService) { }
 
  ngOnInit(): void {
    //$.widget.bridge('uibutton', $.ui.button);
  }

  toggle:any=false;
  menuitem:any=false;

  clickEvent(event:any){
    //if you just want to toggle the class; change toggle variable.
    this.toggle = !this.toggle;       
 }
//   async signout(){
//     // this.ApiService.signOutStudent(this.userForm.id).subscribe(
//     //  async (data: any) => {
//     //     console.log("Student signout successfully:", data);
//     //     this.spinner = false;
//     //     this.spinnerService.hide();
//     localStorage.removeItem('user_district');
//     localStorage.removeItem('user_constituency');
//     localStorage.removeItem('login_user_details');
//     sessionStorage.removeItem('keyName');

//      this.router.navigate(['']);
//      await window.location.reload();
//         // Optionally, perform any additional actions after deletion
//     //   },
//     //   (error: any) => {
//     //     console.error("Error signout student:", error);
//     //   }
//     // );
    
//  }

async signout() {
  Swal.fire({
    title: 'Are you sure you want to sign out?',
    text: 'This will log you out of the system.',
    icon: 'warning',
    iconColor:'#015792',
    showCancelButton: true,
    confirmButtonColor: '#015792',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Yes, sign out!',
    cancelButtonText: 'Cancel'
  }).then(async (result) => {
    if (result.isConfirmed) {
      // Remove items from local storage
      localStorage.removeItem('user_district');
      localStorage.removeItem('user_constituency');
      localStorage.removeItem('login_user_details');
      sessionStorage.removeItem('validUserToken');
      sessionStorage.clear();

      // Navigate to the login page and reload the window
      this.router.navigate(['login']).then(() => {
        window.location.reload();
      });
    } else if (result.dismiss === Swal.DismissReason.cancel) {
      // Reload the page without removing local storage
      window.location.reload();
    }
  });
}

 studentDelete() {
  Swal.fire({
    title: "Are you sure?",
    text: "Your account will be closed permanently!",
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Yes, close it!",
    cancelButtonText: "No, keep it",
    confirmButtonColor: " #e5183b", // Set the confirm button color here
    cancelButtonColor: "#015792", // Set the cancel button color here
  }).then((result) => {
    if (result.isConfirmed) {
      console.log(this.userForm.id);
      this.spinner = true;
      this.spinnerService.show();

      this.ApiService.deleteStudent(this.userForm.id).subscribe(
        (data: any) => {
          console.log("Student deleted successfully:", data);
          this.spinner = false;
          this.spinnerService.hide();
    
          this.router.navigate(['']);
          // Optionally, perform any additional actions after deletion
        },
        (error: any) => {
          console.error("Error deleting student:", error);
        }
      );
    }
  });
}

footerdate=new Date().getFullYear();
}
